import algoliasearch from 'algoliasearch/lite';
import { formatedDay, formatedMonth, formatedPlace } from '../alpine-functions';
import { CREDENTIALS as AlgoliaCredantials } from '../config/algolia';

import { stopScrolling, startScrolling, locale } from '../alpine-functions';

export default (methodic) => ({
  client: null,
  filteredAboutMethodic: [],
  filteredDetailedInformation: [],
  filteredCourses: [],
  filteredDictionary: [],
  indexMethodics: null,
  query: '',
  open: false,
  methodic: methodic,

  init() {
    this.client = algoliasearch(AlgoliaCredantials.app, AlgoliaCredantials.key);
    this.indexMethodics = this.client.initIndex('METHODICS');
    this.indexCourses = this.client.initIndex(`COURSES_${locale()}`);
    this.indexDictionary = this.client.initIndex('DICTIONARY');
  },

  searchQuery() {
    if (this.query.length > 0) {
      this.indexMethodics
        .search(this.query, {
          hitsPerPage: 10,
        })
        .then(({ hits }) => {
          this.filteredAboutMethodic = hits.filter(
            (hit) => !hit.objectID.includes('vice-informaci')
          );
          this.filteredDetailedInformation = hits.filter((hit) =>
            hit.objectID.includes('vice-informaci')
          );
        });
      this.indexCourses
        .search(this.query, {
          hitsPerPage: 6,
        })
        .then(({ hits }) => {
          this.filteredCourses = hits;
        });
      this.indexDictionary
        .search(this.query, {
          hitsPerPage: 6,
        })
        .then(({ hits }) => {
          this.filteredDictionary = hits;
        });
      if (
        this.filteredAboutMethodic.length ||
        this.filteredDetailedInformation.length ||
        this.filteredCourses.length ||
        this.filteredDictionary.length
      ) {
        stopScrolling();
      }
    } else {
      this.resetFilter();
    }
  },

  resetFilter() {
    this.filteredAboutMethodic = [];
    this.filteredDetailedInformation = [];
    this.filteredCourses = [];
    this.filteredDictionary = [];
    this.query = '';
  },

  openSearchModal() {
    this.open = true;
    this.setFocus();
    stopScrolling();
  },

  closeSearchModal() {
    this.resetFilter();
    this.open = false;
    startScrolling();
  },

  setFocus() {
    setTimeout(() => {
      const input = document.getElementById('search-results-search-input');
      input.focus();
    }, 100);
  },

  parseHighlightResult(string) {
    return string.substr(0, 133);
  },

  formateDate(start) {
    return `${formatedDay(start)} ${formatedMonth(start)}`;
  },

  formatedPlace(event_type, city) {
    return formatedPlace(event_type, city);
  },

  //TODO: refactor with multiple currency
  //TODO: free cousres when price is zero
  formatedMoney(czk) {
    return `${parseInt(czk.slice(0, -3)).toLocaleString(locale())} Kč`;
  },

  //TODO: refactor use for for cycle
  level(duration) {
    if (duration < 1) {
      return 3;
    }
    if (duration > 2) {
      return 5;
    }
    return 4;
  },

  //TODO: refactor multiple usage of this function
  tcDuration(duration) {
    if (duration < 1) {
      let customDuration = Math.round(duration * 24);
      if (customDuration === 1) {
        return `${customDuration} hodina`;
      }
      if (customDuration > 1 && customDuration <= 4) {
        return `${customDuration} hodiny`;
      }
      return `${customDuration} hodin`;
    }
    if (duration === 1) {
      return `${duration} den`;
    }
    if (duration > 1 && duration <= 4) {
      return `${duration} dny`;
    }
    return `${duration} dnů`;
  },
});
